;
export default {
    // 角色查询接口
    updateSyncInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/updateSyncInfo', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/sys/getSysList', params, response);
    },
    // 查询同步设置信息
    querySyncInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/querySyncInfo', params, response);
    }
};
